module.exports = __webpack_public_path__ + "img/sub_support_1.33ef8912.png";